import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL;

export const getOfficeSettings = async () => {
  return axios.get(`${api_base_url}/OfficeSettings`).then((res) => {
    return res.data;
  });
};

export const getOfficesFromContext = async () => {
  return axios
    .get(`${api_base_url}/OfficeSettings/AllOfficeFromContext`)
    .then((res) => {
      return res.data;
    });
};

export const getOfficeHours = async () => {
  return axios.get(`${api_base_url}/OfficeSettings/OfficeHours`).then((res) => {
    return res.data;
  });
};
export const getOfficeHierarchy = async () => {
  return axios
    .get(`${api_base_url}/OfficeSettings/OfficeHierarchies`)
    .then((res) => {
      return res.data;
    });
};
export const getOfficeCount = async () => {
  return axios.get(`${api_base_url}/OfficeSettings/OfficeCount`).then((res) => {
    return res.data;
  });
};

export const searchOfficeSettings = async (searchInputsData) => {
  const [_key, filters] = searchInputsData.queryKey;

  //Recontruct filter parameter as Query String for GET Method [FromQuery]
  var queryStrings = new URLSearchParams();
  
  const singleFields = [
    "OfficeId",
    "OfficeCode",
    "OfficeName",
    "OfficeStatus",
    "StoreNumber",
    "ZipCode",
    "Address",
    "AgencyName",
    "IsFranchise",
    "IsConfie",
    "OfficeType",
    "Channel",
    "isOfficeOpen",
    "isOfficeDark",
    "isSPLCOffices",
  ];

  const arrayFields = [
    "GLBranch",
    "City",
    "State",
    "TargetSystem",
    "Carriers",
    "ProducerCode",
    "Brand",
    "BrandName",
    "ChannelId",
    "Phone",
  ];

  const numericArrayFields = [
    "OfficeStatusId",
    "OfficeTypeId",
    "OfficeNameId",
    "OfficeStoreNumberId",
  ];
  
  singleFields.forEach((key) => {
    appendValue(queryStrings, key, filters[key]);
  });
  
  arrayFields.forEach((key) => {
    appendArray(queryStrings, key, filters[key]);
  });
  
  numericArrayFields.forEach((key) => {
    appendNumberArray(queryStrings, key, filters[key]);
  });
  
  appendArray(queryStrings, "OfficeCodeId", filters.OfficeCodeId);

  if (filters.DistrictCode?.length) {
    queryStrings.append("DistrictCode", filters.DistrictCode.join(","));
  }

  var filterParams = {
    params: queryStrings,
  };

  return axios
    .get(`${api_base_url}/OfficeSettings/SearchOfficeSetting`, filterParams)
    .then((res) => {
      return res.data;
    });
};

export const getAgentRecord = async (officeId) => {
  let offId = officeId ?? 0;
  const { data } = await axios.get(
    `${api_base_url}/OfficeSettings/GetAgentRecord/${offId}`
  );
  return data;
};

export const getProducerCodeByAgency = async (officeId) => {
  let ocproducerData;
  await axios
    .get(`${api_base_url}/ProducerCode/${officeId}`)
    .then((res) => (ocproducerData = res.data));
  return ocproducerData;
};

export const GetProducerCodeListByOfficeCode = async (officeCode) => {
  let ocproducerData;
  await axios
    .post(`${api_base_url}/ProducerCode/${officeCode}`)
    .then((res) => (ocproducerData = res.data));
  return ocproducerData;
};

export const getOfficeById = async (officeId) => {
  let officeData;
  await axios
    .get(`${api_base_url}/OfficeSettings/${officeId}`)
    .then((res) => (officeData = res.data));
  return officeData;
};

export const getOfficeByOfficeHierarchyId = async (officeHierarchyId) => {
  let officeData;
  await axios
    .get(
      `${api_base_url}/OfficeSettings/GetOfficeByOfficeHierarchyId/${officeHierarchyId}`
    )
    .then((res) => (officeData = res.data));
  return officeData;
};

//Insert New Office Setting
export const addOffice = async (newOffice) => {
  return await axios.post(`${api_base_url}/OfficeSettings`, { ...newOffice });
};

//Update Office Setting
export const updateOffice = async (editOffice) => {
  const formData = new FormData();

  for (const properties in editOffice) {
    if (
      properties === "fileImageLists" ||
      properties === "onchangeToBackup" ||
      properties === "onchangeToUpdate" ||
      properties === "generalInformationSection" ||
      properties === "officeHoursSection" ||
      properties === "officeHierarchyAndLeadershipSection" ||
      properties === "officeDetails"
    ) {
      editOffice[properties].forEach((obj, i) =>
        Object.entries(obj)?.forEach(([key, value]) => {
          if (value) {
            formData.append(`${properties}[${i}].${key}`, value);
          }
        })
      );
    } else if (
      properties === "fileImageForDelete" ||
      properties === "fileImages"
    ) {
      editOffice[properties].forEach((obj, i) => {
        Object.entries(obj).forEach(([key, value]) => {
          formData.append(`${properties}[${i}].${key}`, value);
          formData.append(
            `${properties}[${i}].modifiedDate`,
            new Date().toISOString()
          );
        });
      });
    } else if (properties === "associatedEmployeeIds") {
      editOffice[properties].forEach((value, i) => {
        if (value) {
          formData.append(`${properties}[${i}]`, value);
        }
      });
    } else if (
      editOffice[properties] !== null &&
      editOffice[properties] !== undefined
    ) {
      formData.append(`${properties}`, editOffice[properties]);
    }
  }

  return await axios.put(
    `${api_base_url}/OfficeSettings/${editOffice.officeId}`,
    formData
  );
};

export const downloadOfficeSettingsTemplate = async () => {
  var response = await axios.get(
    `${api_base_url}/OfficeSettings/download/template`,
    {
      headers: { "Content-Type": "application/json" },
      responseType: "blob",
    }
  );
  return response;
};

//multi detelete
export const deleteOfficeSettings = async (officeIds, userName) => {
  return await axios.delete(`${api_base_url}/OfficeSettings/${userName}`, {
    data: officeIds,
  });
};

//Download Office Reports
export const getOfficeByIdList = async (officeIds) => {
  return await axios
    .post(`${api_base_url}/OfficeSettings/SearchOfficeByIdList`, officeIds)
    .then((res) => {
      return res.data;
    });
};

//Export officeof data
export const exportOfficeSettings = async (officeIds) => {
  var response = await axios.post(
    `${api_base_url}/OfficeSettings/ExportExcel`,
    officeIds,
    {
      headers: { "Content-Type": "application/json" },
      responseType: "blob",
    }
  );
  return response;
};

export const validateOfficeMassUpload = (data) => {
  return axios
    .post(`${api_base_url}/OfficeSettings/validate/`, data)
    .then((res) => {
      if (res.status === 400) {
        res.json();
      }
      return res.data;
    });
};

export const massUploadOfficeSettings = async (data) => {
  return await axios.post(`${api_base_url}/OfficeSettings/mass-upload/`, data);
  // .then((res) => {
  //   return res;
  // });
};

export const addAgentRecord = (data) => {
  return axios
    .post(`${api_base_url}/OfficeSettings/AgentRecord`, data)
    .then((res) => {
      return res;
    });
};

export const updateAgentRecord = (data) => {
  return axios
    .put(
      `${api_base_url}/OfficeSettings/AgentRecord/${data.agentRecordId}`,
      data
    )
    .then((res) => {
      return res;
    });
};

export const deleteAgentRecord = (id) => {
  return axios
    .delete(`${api_base_url}/OfficeSettings/AgentRecord/${id}`)
    .then((res) => res.data);
};

export const getOfficeByOfficeId = async (officeId) => {
  return await axios
    .get(`${api_base_url}/OfficeSettings/SearchOfficeById/${officeId}`)
    .then((res) => res.data);
};

export const getOfficeHierarchyDistricts = async () => {
  return axios
    .get(`${api_base_url}/OfficeSettings/OfficeHierarchyDistrictCodes`)
    .then((res) => {
      if (res && res.status === 200) {
        return res.data;
      } else {
        return [];
      }
    });
};

export const getActiveOfficeBMO = async () => {
  return await axios
    .get(`${api_base_url}/OfficeSettings/ActiveOfficeBMO`)
    .then((results) => {
      if (results) {
        return results.data;
      }
    });
};

export const getActiveOfficeDivision = async () => {
  return await axios
    .get(`${api_base_url}/OfficeSettings/ActiveOfficeDivision`)
    .then((results) => {
      if (results) {
        return results.data;
      }
    });
};

export const getActiveTexasGrouping = async () => {
  return await axios
    .get(`${api_base_url}/OfficeSettings/ActiveTexasGrouping`)
    .then((results) => {
      if (results) {
        return results.data;
      }
    });
};

export const getOfficeLegalEntities = async () => {
  return await axios
    .get(`${api_base_url}/OfficeSettings/OfficeLegalEntities`)
    .then((results) => {
      if (results) {
        return results.data;
      }
    });
};

export const getPendingOfficeCount = async () => {
  return axios
    .get(`${api_base_url}/OfficeSettings/GetPendingCount`)
    .then((res) => {
      return res.data;
    });
};

export const getOpenOfficeCount = async () => {
  return axios
    .get(`${api_base_url}/OfficeSettings/GetOpenOfficeCount`)
    .then((res) => {
      return res.data;
    });
};

export const getDarkOfficeCount = async () => {
  return axios
    .get(`${api_base_url}/OfficeSettings/GetDarkCount`)
    .then((res) => {
      return res.data;
    });
};

export const getDarkCovidOfficeCount = async () => {
  return axios
    .get(`${api_base_url}/OfficeSettings/GetDarkCovidCount`)
    .then((res) => {
      return res.data;
    });
};

export const getClosedLeaseEndedCount = async () => {
  return axios
    .get(`${api_base_url}/OfficeSettings/GetClosedLeaseEndedCount`)
    .then((res) => {
      return res.data;
    });
};

export const getClosedLeaseActiveCount = async () => {
  return axios
    .get(`${api_base_url}/OfficeSettings/GetClosedLeaseActiveCount`)
    .then((res) => {
      return res.data;
    });
};

export const getRefranchisedLeaseActiveOfficeCount = async () => {
  return axios
    .get(`${api_base_url}/OfficeSettings/GetRefranchisedLeaseActiveOfficeCount`)
    .then((res) => {
      return res.data;
    });
};

export const getRefranchisedLeaseEndedOfficeCount = async () => {
  return axios
    .get(`${api_base_url}/OfficeSettings/GetRefranchisedLeaseEndedOfficeCount`)
    .then((res) => {
      return res.data;
    });
};

export const getRetailOffices = async () => {
  return axios
    .get(`${api_base_url}/OfficeSettings/GetRetailOffices`)
    .then((res) => {
      return res.data;
    });
};

export const getOfficeCities = async () => {
  const { data } = await axios.get(
    `${api_base_url}/OfficeSettings/GetOfficeCityList`
  );
  return data;
};

export const getProducerCodes = async () => {
  const { data } = await axios.get(
    `${api_base_url}/OfficeSettings/GetProducerCodeList`
  );
  return data;
};

export const getOfficePhones = async () => {
  const { data } = await axios.get(
    `${api_base_url}/OfficeSettings/GetOfficePhoneList`
  );
  return data;
};

export const getTotalOfficesCount = async () => {
  return axios
    .get(`${api_base_url}/OfficeSettings/GetTotalOfficesCount`)
    .then((res) => {
      return res.data;
    });
};

export const getOfficeStates = async () => {
  const { data } = await axios.get(
    `${api_base_url}/OfficeSettings/OfficeStates`
  );
  return data;
};

export const getEntity = async () => {
  const { data } = await axios.get(`${api_base_url}/OfficeSettings/Entity`);
  return data;
};

export const getOfficeBanks = async () => {
  const { data } = await axios.get(
    `${api_base_url}/OfficeSettings/OfficeBanks`
  );
  return data;
};

export const getOfficeAccounts = async () => {
  const { data } = await axios.get(
    `${api_base_url}/OfficeSettings/OfficeAccounts`
  );
  return data;
};

export const getOfficeStatus = async () => {
  const { data } = await axios.get(
    `${api_base_url}/OfficeSettings/OfficeStatus`
  );
  return data;
};

export const getOfficeStatusDetails = async () => {
  const { data } = await axios.get(
    `${api_base_url}/OfficeSettings/OfficeStatusDetails`
  );
  return data;
};
export const getTargetSystem = () => {
  return axios
    .get(`${api_base_url}/OfficeSettings/targetsystem`)
    .then((res) => {
      return res.data;
    });
};

export const getChannel = async () => {
  const { data } = await axios.get(`${api_base_url}/OfficeSettings/Channel`);
  return data;
};

export const getBusinessOperation = async () => {
  return await axios
    .get(`${api_base_url}/OfficeSettings/BusinessOperation`)
    .then((res) => res.data);
};
export const getSalesType = async () => {
  return await axios
    .get(`${api_base_url}/OfficeSettings/SalesType`)
    .then((res) => res.data);
};
export const getOfficeType = async () => {
  const { data } = await axios.get(`${api_base_url}/OfficeSettings/OfficeType`);
  return data;
};

export const getOfficeOrigin = async () => {
  const { data } = await axios.get(
    `${api_base_url}/OfficeSettings/OfficeOrigin`
  );
  return data;
};

export const getOfficeBrands = () => {
  return axios.get(`${api_base_url}/OfficeSettings/officeBrand`).then((res) => {
    return res.data;
  });
};

export const getBillsOfficeHierarchy = async () => {
  return axios
    .get(`${api_base_url}/OfficeSettings/BillOfficeHierarchies`)
    .then((res) => {
      return res.data;
    });
};

export const getActiveOfficeDepartment = async () => {
  return await axios
    .get(`${api_base_url}/OfficeSettings/ActiveOfficeDepartment`)
    .then((results) => {
      if (results) {
        return results.data;
      }
    });
};

export const getOfficeImageSection = async () => {
  return axios
    .get(`${api_base_url}/OfficeSettings/OfficeImageSection`)
    .then((res) => {
      return res.data;
    });
};

//For image category options
export const getOfficeImageCategory = async () => {
  return axios
    .get(`${api_base_url}/OfficeSettings/OfficeImageCategory`)
    .then((res) => {
      return res.data;
    });
};

//For image label options
export const getOfficeImageLabel = async () => {
  return axios
    .get(`${api_base_url}/OfficeSettings/OfficeImageLabel`)
    .then((res) => {
      return res.data;
    });
};

//Get file image
export const getFileImage = async (file) => {
  const encodedFileData = encodeURIComponent(file);

  const data = await axios.get(
    `${api_base_url}/OfficeSettings/GetFileImage?fileName=${encodedFileData}`,
    {
      responseType: "arraybuffer",
    }
  );
  return data;
};

export const getEmployeeReportsTo = async (officeCode) => {
  return await axios
    .get(`${api_base_url}/OfficeSettings/EmployeeReportsTo/${officeCode}`)
    .then((res) => res.data);
};

export const getEmployeeReportsToCount = async (officeCode) => {
  return await axios
    .get(`${api_base_url}/OfficeSettings/EmployeeReportsToCount/${officeCode}`)
    .then((res) => {
      return res.data;
    });
};

export const getEmployeesAssociatedToOffice = async () => {
  return axios
    .get(`${api_base_url}/OfficeSettings/EmployeesAssociatedToOffice`)
    .then((res) => {
      return res.data;
    });
};

export const getActivePhoneSetNumber = async () => {
  const response = await axios.get(
    `${api_base_url}/OfficeSettings/ActivePhoneSetNumber`
  );
  return response.data;
};

// Helpers
const appendValue = (queryStrings, key, value) => {
  if (value !== undefined && value !== null && value !== "") {
    queryStrings.append(key, String(value));
  }
};

const appendArray = (queryStrings, key, values) => {
  if (!values?.length) return;

  values.forEach((value) => queryStrings.append(key, String(value)));
};

const appendNumberArray = (queryStrings, key, values) => {
  if (!values?.length) return;

  values.forEach((value) => queryStrings.append(key, String(Number(value))));
};
